import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

import styles from './AppDetails.module.css'

import appslist from '../appslist'
import AppDetailContext from './AppDetailContext'

import HappyFoxWorkflows from './integrations/HappyFoxWorkflows'
import Zapier from './integrations/Zapier'
import Calendly from './integrations/Calendly'
import HappyFoxHelpdesk from './integrations/HappyFoxHelpdesk'
import HappyFoxChat from './integrations/HappyFoxChat'
import RestAPI from './integrations/RestAPI'
import Button from 'Design/components/Button'
import Heading from 'Design/components/Heading'
import BackButton from '../components/BackButton'
import GoogleAnalytics from './integrations/GoogleAnalytics'

const DefaultComponent = () => 'Invalid App'

const componentList = {
  happyfox_workflows: HappyFoxWorkflows,
  zapier: Zapier,
  calendly: Calendly,
  happyfox_helpdesk: HappyFoxHelpdesk,
  happyfox_chat: HappyFoxChat,
  rest_api: RestAPI,
  google_analytics: GoogleAnalytics
}

const AppDetails = (props) => {
  const { detail } = props

  const Integration = componentList[detail.app_type] || DefaultComponent

  const handleDetailClick = () => {
    window.open(detail.supportArticleLink, '_blank')
  }

  return (
    <AppDetailContext.Provider value={detail}>
      <div className={styles.Container}>
        <div className={styles.SideContent}>
          <BackButton />
          <div className={styles.LogoContainer}>
            <img className={styles.BrandImage} src={detail.brandImage} alt={detail.name} />
          </div>
          <Heading level={2} className={styles.Title}>
            {detail.name} & Chatbot <br /> integrations details
          </Heading>
          <p className={styles.Description}>{detail.description}</p>
          {detail.supportArticleLink && (
            <Button variant='secondary' onClick={handleDetailClick}>
              Detailed Guide
            </Button>
          )}
        </div>
        <div className={styles.MainContent}>
          <Integration />
        </div>
      </div>
    </AppDetailContext.Provider>
  )
}

const AppDetailsContainer = (props) => {
  const { appName } = useParams()

  const detail = appslist.find((app) => app.app_type === appName)

  if (!detail) {
    return <Navigate to='../' replace />
  }

  return <AppDetails detail={detail} {...props} />
}

export default AppDetailsContainer
